// extracted by mini-css-extract-plugin
module.exports = {"input":"input--VOXHQ","editing":"editing--2GJSX","enter":"enter--12U-1","delete":"delete--3L0o-"};
    if(module.hot) {
      // 1732531520950
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  